import { ProjectCategory } from '@/features/projects/shared/types/category';
import { supabase } from '@/lib/supabase';

export type ProjectCategories = {
  level1: ProjectCategory[];
  level2: ProjectCategory[];
  level3: ProjectCategory[];
};

export async function getProjectCategories(): Promise<ProjectCategories> {
  const { data, error } = await supabase
    .from('project_categories')
    .select('*')
    .order('level', { ascending: true });

  if (error) {
    throw error;
  }

  const level1Categories = data.filter((cat) => cat.level === 1);
  const level2Categories = data.filter((cat) => cat.level === 2);
  const level3Categories = data.filter((cat) => cat.level === 3);

  return {
    level1: level1Categories,
    level2: level2Categories,
    level3: level3Categories,
  };
}
